import React from 'react';
import styled from 'styled-components';
import { mapping } from './assets';

export interface GameHeaderProps {
  score: number;
  speed: number;
  distance: number;
  handlerClick: () => void;
}

const StyledGameHeader = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  font-size: ${({ theme }) => theme.fontSize.header}px;
  background: linear-gradient(#000000 -4.63%, rgba(0, 0, 0, 0) 91.2%);
  box-sizing: border-box;
  padding: 60px 60px 0;
  z-index: 999;
`;

const Actions = styled.div`
  flex: 1 1 100%;
`;

const Pause = styled.button`
  font-family: ${({ theme }) => theme.family};
  font-size: ${({ theme }) => theme.fontSize.header}px;
  color: ${({ theme }) => theme.colors.text};
  font-weight: 400;
  line-height: 1.1;
  background: none;
  outline: none;
  border: 0;
  cursor: pointer;
  padding: 0;
`;

const Speed = styled.div`
  flex: 1 1 100%;
  text-align: center;
`;

const Total = styled.div`
  flex: 1 1 100%;
  display: flex;
  column-gap: 50px;
  justify-content: flex-end;
`;

const Score = styled.div`
  position: relative;
  padding-left: 70px;
`;

const Money = styled.img`
  position: absolute;
  left: -100px;
  top: -45px;
`;

export const GameHeader: React.FC<GameHeaderProps> = ({ score, distance, speed, handlerClick }) => (
  <StyledGameHeader>
    <Actions>
      <Pause onClick={handlerClick}>II</Pause>
    </Actions>
    <Speed>
      Speed x{speed}
    </Speed>
    <Total>
      <Score>
        <Money src={mapping.money['1x']} srcSet={`${mapping.money['2x']} 2x`} />
        {String(score).padStart(3, '0')}
      </Score>
      <div>
        {String(distance).padStart(4, '0')} m
      </div>
    </Total>
  </StyledGameHeader>
);
